import { Switch } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { styled } from '@mui/system';

export const OrangeGreenSwitch = styled(Switch)(({ theme }) => ({
  cursor: 'pointer',
  '& .MuiSwitch-switchBase ': {
    color: 'rgba(213, 153, 0, 1)',
    '&:hover': {
      backgroundColor: alpha('rgba(213, 153, 0, 1)', theme.palette.action.hoverOpacity)
    }
  },
  '& .MuiSwitch-switchBase + .MuiSwitch-track': {
    backgroundColor: 'rgba(213, 153, 0, 1)'
  },
  '& .MuiSwitch-switchBase.Mui-disabled': {
    color: '#FAF2E0'
  },
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: 'rgba(0, 138, 6, 1)',
    '&:hover': {
      backgroundColor: alpha('rgba(0, 138, 6, 1)', theme.palette.action.hoverOpacity)
    }
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#D8F8D9',
    opacity: 1
  },
  '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled': {
    color: '#EBFBEC'
  },
  '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track': {
    backgroundColor: '#EBFBEC',
    opacity: 1
  }
}));
